export const removeParamFromUrl = (key: string, value: string): void => {
  const parsedUrl = new URL(window.location.href);
  const filteredValues = parsedUrl.searchParams.getAll(key).filter(v => v !== value);
  parsedUrl.searchParams.delete(key);
  filteredValues.forEach(filteredValue => parsedUrl.searchParams.append(key, filteredValue));
  window.history.replaceState({}, '', parsedUrl.toString());
};
